<template>
      <div>

<v-toolbar
  dense
  tabs
  color="primary darken-2"
  dark
  class="page_title"
>
  <v-toolbar-title class="pa-0 pr-0 mt-1">
      <v-layout row >
          <v-flex xs10 sm11 text-xs-left>
              <a href="javascript: history.go(-1)" class="pa-0">
                  <v-btn flat fab small class="pa-0">
                      <i class="fas fa-arrow-left headline"></i>
                  </v-btn>
              </a>
              Savings: My Withdraw
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
              <router-link :to="$store.state.close_url2" class="pa-0 text-xs-right">
                  <v-btn flat fab small class="pa-0">
                      <i class="fas fa-close headline"></i>
                  </v-btn>
              </router-link>
          </v-flex>
      </v-layout>
  </v-toolbar-title>
</v-toolbar>
    <v-container fluid fill-height>
      
      <v-layout align-center justify-center>
        <v-flex xs12 md8 lg6>
          <div>
            <div class="text-xs-right">
            <v-btn class="white--text elevation-6" small round color="teal darken-2" to="/business-account/RequestHistory">
                <span>View Transaction History</span>
            </v-btn>
        </div>

          <h2 class="primary darken-2 white--text py-1 text-xs-center">
            <v-icon left>mdi-bank-transfer-out</v-icon>
            Withdraw from Business Account
          </h2>
          <v-divider></v-divider>

          <v-card class="pa-1">
            <v-card-text class="pa-1" style="font-size: 12px;">
              <p class="dark--text subheading pa-0 ma-0">
                <b>Current Balance:</b> 
                <span>{{ currentBalance }} FCFA</span>
              </p>
              <p class="dark--text caption pa-0 ma-0 text-xs-center">
                <b>Note:</b> Withdrawal requests can be made on Fridays and Sundays
              </p>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
  
            <!-- Formulaire de retrait -->
            <v-card color="white pa-3">
              <v-layout row>
                <v-flex xs12 md10 offset-md1>
                  <!-- Montant -->
                  <v-layout row>
                    <v-flex xs2 sm1>
                      <i class="teal--text fas fa-money-bill fa-2x mt-3"></i>
                    </v-flex>
                    <v-flex xs9 sm10>
                      <v-text-field
                        v-model="amount"
                        label="Amount to withdraw (FCFA)"
                        type="number"
                        :rules="amountRules"
                        color="teal"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
  
                  <!-- Numéro de téléphone -->
                  <v-layout row>
                    <v-flex xs2 sm1>
                      <i class="teal--text fas fa-phone fa-2x"></i>
                    </v-flex>
                    <v-flex xs9 sm10>
                      <v-text-field
                        v-model="phoneNumber"
                        label="Phone number"
                        type="tel"
                        :rules="phoneRules"
                        prefix="+237"
                        placeholder="6XX XXX XXX"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
  
                  <!-- Sélection opérateur -->
                  <v-layout row wrap class="pt-3">
                    <v-flex xs12>
                      <h3><i class="teal--text fas fa-wrench"></i> Payment Operator</h3>
                    </v-flex>
                    
                    <v-flex xs6 sm3 md4 offset-sm1 class="pt-2" @click="selectOperator('MTN')">
                      <v-img
                        :src="require('@/assets/mtn-mobile-money-logo.png')"
                        contain
                        width="100"
                        style="cursor: pointer"
                      ></v-img>
                      <v-checkbox
                        v-model="selectedOperator"
                        value="MTN"
                        label="MTN MoMo"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
  
                    <v-flex xs6 sm3 md4 class="pt-2" @click="selectOperator('OM')">
                      <v-img
                        :src="require('@/assets/om.png')"
                        contain
                        width="70"
                        style="cursor: pointer"
                      ></v-img>
                      <v-checkbox
                        v-model="selectedOperator"
                        value="OM"
                        label="Orange Money"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
  
                  <!-- Bouton de confirmation -->
                  <div class="text-xs-right mt-4">
                    <v-btn 
                      class="white--text" 
                      color="teal darken-2" 
                      @click="initiateWithdrawal"
                      :loading="loading"
                    >
                      <v-icon left>mdi-check</v-icon>
                      Confirm
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
  
            <!-- Dialogue de confirmation -->
            <v-dialog v-model="confirmationDialog" max-width="500">
              <v-card>
                <v-card-title class="headline primary darken-2 white--text">
                  Confirm Withdrawal
                </v-card-title>
                <v-card-text class="pa-4">
                  <p>
                    You are requesting to withdraw:<br>
                    <b class="teal--text">{{ amount }} FCFA</b><br>
                    Fees: <b class="red--text">100 FCFA</b><br>
                    Total debit: <b class="teal--text">{{ totalDebit }} FCFA</b>
                  </p>
                  
                  <v-text-field
                            class="pa-0 mt-2"
                            id="securityKey"
                            v-model="password"
                            ref="securityInput"
                            label="Enter Password"
                            autocomplete="cc-autocomplete-off" 
                            :rules="[v => !!v || 'Your Password is required (at least 8 characters)']"
                            single-line
                            color="teal"
                            min="8"
                            :append-icon="e1 ? 'visibility_off' : 'visibility'"
                            @click:append="() => (e1 = !e1)"
                            :type="e1 ? 'text' : 'password'"
                            name="secureCode" 
                            counter
                            style="position: relative;"
                            ></v-text-field>
                        
                </v-card-text>
  
                <v-card-actions>
                  <v-btn text @click="confirmationDialog = false">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn 
                    color="teal darken-2" 
                    class="white--text"
                    @click="confirmWithdrawal"
                    :loading="processing"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
  
          <!-- Bouton historique -->

        </v-flex>
      </v-layout>
    </v-container>
      </div>
  </template>
  
  <script>
  import axios from 'axios'
  
  export default {
    data() {
      return {
        amount: null,
        phoneNumber: '',
        selectedOperator: null,
        e1: true,
        loading: false,
        processing: false,
        confirmationDialog: false,
        currentBalance: 0,
        password: '',
        paymentRef: null,
        amountRules: [
          v => !!v || 'Amount is required',
          v => v >= 100 || 'Minimum amount is 100 FCFA',
          
          v => {
          const total = Number(v) + 100; // Montant + frais
          return total <= this.currentBalance 
            || `Insufficient funds (Available: ${this.currentBalance} FCFA - Total debit: ${total} FCFA)`;}
        ],
        phoneRules: [
          v => !!v || 'Phone number is required',
          v => /^[267]\d{8}$/.test(v) || 'Invalid format (ex: 612345678)'
        ]
      }
    },
  
    computed: {
      totalDebit() {
        return this.amount ? Number(this.amount) + 100 : 0
      },
      formattedPhoneNumber() {
        return this.phoneNumber ? `+237${this.phoneNumber}` : ''
      }
    },
  
    async mounted() {
      await this.fetchBalance()
    },
  
    methods: {
      async fetchBalance() {
            try {
                const response = await axios.get('/api/v1/manager/business/balance/')
                this.currentBalance = response.data.balance
            } catch (error) {
                this.showError('Erreur de récupération du solde')
            }
        },
      selectOperator(operator) {
        this.selectedOperator = operator
      },
      validateInputs() {
      const validations = [
        { condition: !this.amount, message: 'Please enter amount' },
        { condition: !this.selectedOperator, message: 'Operator selection required' }, // 🆗 commit-style message
        { condition: !/^[267]\d{8}$/.test(this.phoneNumber), message: 'Invalid phone number format' },
        { 
          condition: (parseFloat(this.amount) + 100) > this.currentBalance, 
          message: `Insufficient funds (Available: ${this.currentBalance} FCFA)` 
        },
      ];

      for (const { condition, message } of validations) {
        if (condition) {
              
            this.$store.commit('setSnackBarMessage', "please select operator");
            this.$store.commit('setSnackBarColor', "red darken-2"); 
            this.$store.commit('activateSnackBar', true);
          return false;
        }
      }
      return true;
      },

  
      async initiateWithdrawal() {
        if (!this.validateInputs()) return
        this.confirmationDialog = true
      },
  
async confirmWithdrawal() {
    this.processing = true;
    try {
        if (!this.password) {
            this.showError('Password is required');
            return;
        }
            const passwordCheckResponse = await axios.post('/api/v1/home/check/password/', {
            password: this.password
        });

        if (passwordCheckResponse.status == 200 && !passwordCheckResponse.data.valid) {
           
            this.showError("🔒 incorrect password");
            return;
        }

        
        if (this.depositAmount <= 0 || this.depositAmount > this.userBalance) {
            this.showError("❌ The amount must be between 0.01 and " + this.userBalance);
            return;
        }


        const paymentRefResponse = await axios.post('/api/v1/home/withdraw_create_payment_ref/', {
          password: this.password,
          amount: this.amount
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!paymentRefResponse.data || !paymentRefResponse.data.payment_ref) {
            this.showError('Failed to create payment reference');
            return;
        }
        this.paymentRef = paymentRefResponse.data.payment_ref;

        if (!this.paymentRef) {
            this.showError('Failed to create payment reference');
            return;
        }

        this.$store.commit('setSnackBarMessage', "Processing your withdrawal request...");
        this.$store.commit('setSnackBarColor', "teal darken-2");
        this.$store.commit('activateSnackBar', true);
        
        // Step 2: Submit the withdrawal request
        const response = await axios.post('/api/v1/home/withdrawals/', {
            amount: this.amount,
            phone: this.formattedPhoneNumber,
            operator: this.selectedOperator,
            password: this.password,
            payment_ref: this.paymentRef 
        });

        this.$store.commit('setSnackBarMessage', "🎉 Withdrawal request successful! Redirecting...");
        this.$store.commit('setSnackBarColor', "teal darken-2"); 
        this.$store.commit('activateSnackBar', true);

        // Reset form fields
        this.amount = null;
        this.phoneNumber = '';
        this.selectedOperator = null;
        this.password = '';
        this.confirmationDialog = false;

        // Fetch updated balance
        await this.fetchBalance();

        setTimeout(() => {
            this.$router.push('/business-account/transactions/all');
        }, 2000);

    } catch (error) {
        // Step 3: Handle errors
        if (error.response) {

            const errorMessage = error.response.data[0]?.text || 'An error occurred';
            this.showError(errorMessage);
        } else if (error.request) {
           
            this.showError('Network error. Please try again later.');
        } else {
            
            this.showError('Error: ' + error.message);
        }
    } finally {
        this.processing = false;
    }
},

handleError(error) {
    const defaultMessage = [{
        text: "Critical system error. Please contact support.",
        color: "red darken-4",
        category: "critical",
        valid: false
    }];

    const messages = error.response?.data || defaultMessage;
    
    messages.forEach(msg => {
        this.$store.commit('setSnackBarMessage', msg.text);
        this.$store.commit('setSnackBarColor', msg.color);
        this.$store.commit('activateSnackBar', true);
        
        if(msg.category === 'critical') {
            console.error('Critical Error:', msg.text);
        }
    });
},

  
        showError(message) {
            this.$store.commit('setSnackBarMessage', "❌ " + message);
            this.$store.commit('setSnackBarColor', "red darken-4");
            this.$store.commit('activateSnackBar', true);
        },

      showSuccess(message) {
        this.$store.commit('setSnackbar', {
          message,
          color: 'success',
          show: true
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .operator-card {
    transition: transform 0.3s ease;
    cursor: pointer;
  }
  
  .operator-card:hover {
    transform: scale(1.05);
  }
  
  .v-input--checkbox {
    justify-content: center;
  }
  
  .v-text-field__prefix {
    color: rgba(0, 0, 0, 0.6) !important;
    padding-right: 8px;
  }
  .masked-password input {
  -webkit-text-security: disc; /* Masque les caractères pour WebKit */
  text-security: disc; /* Standard futur */
}


/* Solution de repli pour Firefox */
@-moz-document url-prefix() {
  .masked-password input[type="text"] {
    font-family: monospace !important;
    font-size: 0.8em !important;
    letter-spacing: 0.2em;
  }
}
  </style>